const LogoText = () => {
    return (
        <span className="font-bold">
            <span className="text-primaryDark">Pen</span>
            <span className="text-primary">smart</span>
        </span>
    )
}
export default LogoText;